import React, { useContext } from 'react';
import { AuthContext } from '../reducers/Auth/AuthContext';
import Imagez from '../lib/reusable/Imagez';
import { ProductText } from '../lib/reusable/typography';
import config from '../utils/config';

export const OrderProduct = (props) => {
  const { productData, noprice, style } = props;
  const [authState] = useContext(AuthContext);
  const {
    user: { placeId },
  } = authState;

  const {
    product: { name, cost, currency, id },
    count,
    toppings,
  } = productData;

  let productHasToppings = false;
  for (const topping of toppings) {
    if (topping.length > 0) {
      productHasToppings = true;
      break;
    }
  }

  const image = `${config.uri.bucket}/${placeId}/low/${id}.jpg?time=${new Date().getTime()}`;
  const size = '3rem';
  return (
    <div
      style={{
        borderBottom: noprice ? 'none' : '1px solid #00000015',
        margin: '0 10px 0 10px',
        padding: '10px 0 10px 0',
        ...style,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              height: size,
              width: size,
              maxHeight: size,
              maxWidth: size,
              minHeight: size,
              minWidth: size,
            }}
          >
            <Imagez
              image={image}
              hasGradient
              br="8px"
              dropShadow
              text="N/A"
              fontSize="1rem"
              height={size}
            />
          </div>
          <h3 className="f3b f10 p-2 ml-4">{`${count}x`}</h3>
          <h3 className="f3 f09 p-2 ml-8">{`${name}`}</h3>
        </div>
        {!noprice && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h3 className="f3b f09 p-2">{`${Number(count) * cost}${currency}`}</h3>
          </div>
        )}
      </div>
      {productHasToppings &&
        toppings.map((foundToppings, index) => {
          return (
            <div key={index} style={{ marginLeft: '58px' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <h3 className="f3b f06 p-2">{`${name} ${index + 1}`}</h3>
                <div />
                <div />
              </div>
              {foundToppings.map((topping) => (
                <div
                  className="f-c f-jcsb f-aic ml-32"
                  key={topping.id}
                  style={{
                    borderBottom: noprice ? 'none' : '1px solid #00000015',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h3 className="f3b f08 p-2">{topping.name.toLocaleUpperCase()}</h3>
                  </div>
                  {!noprice && <h3 className="f3b f06 p-2 mr-4">{`${topping.cost}${currency}`}</h3>}
                </div>
              ))}
            </div>
          );
        })}
    </div>
  );
};
